import { Check } from "lucide-react";
import { cn } from "@/utils/cn";

type ManpowerViewFilterCheckboxesProps = {
  filterExceed: boolean;
  filterBelow: boolean;
  onToggleExceed: () => void;
  onToggleBelow: () => void;
};

/** 나열/캘린더 뷰에서 ‘기본 설정 인원’ 대비 초과·미만 하이라이트 필터 */
export function ManpowerViewFilterCheckboxes({
  filterExceed,
  filterBelow,
  onToggleExceed,
  onToggleBelow,
}: ManpowerViewFilterCheckboxesProps) {
  return (
    <div className="flex items-center gap-x-4">
      <label
        className="group flex items-center gap-x-1 cursor-pointer font-pretendard text-sm text-text-main2"
        onClick={onToggleExceed}
      >
        <div
          className={cn(
            "flex h-5 w-5 cursor-pointer items-center justify-center rounded-[3px] border",
            filterExceed
              ? "border-manpower-exceed-border bg-manpower-exceed-bg"
              : "border-[#ccc] bg-white"
          )}
        >
          {filterExceed && (
            <Check
              size={11}
              strokeWidth={3}
              className="text-manpower-exceed-border"
            />
          )}
        </div>
        <span className="group-hover:underline">기본 설정 인원 초과</span>
      </label>

      <label
        className="group flex items-center gap-x-1 cursor-pointer font-pretendard text-sm text-text-main2"
        onClick={onToggleBelow}
      >
        <div
          className={cn(
            "flex h-5 w-5 cursor-pointer items-center justify-center rounded-[3px] border",
            filterBelow
              ? "border-manpower-below-border bg-manpower-below-bg"
              : "border-[#ccc] bg-white"
          )}
        >
          {filterBelow && (
            <Check
              size={11}
              strokeWidth={3}
              className="text-manpower-below-border"
            />
          )}
        </div>
        <span className="group-hover:underline">기본 설정 인원 미만</span>
      </label>
    </div>
  );
}
